import type { UserProfile } from "@/types/UserProfile";

export function useProfile() {
  const profile = useState<UserProfile | null>("profile", () => null);
  const loading = useState("profileLoading", () => false);

  const fetchProfile = async () => {
    const { loggedIn } = useUserSession();

    if (!loggedIn.value) {
      return;
    }

    const { data, error } = await useApi<UserProfile>(
      `/v1/user`,
      {
        headers: { 'x-include-domain-contracts': 'flags' }
      }
    );

    if (data.value && !error.value) {
      profile.value = data.value;
    }

    loading.value = false;
  };

  const getProfile = async () => {
    if (!profile.value && !loading.value) {
      await fetchProfile();
    }
    return profile.value;
  };

  const refreshProfile = async () => {
    await fetchProfile();
  };

  return {
    profile,
    getProfile,
    refreshProfile,
  };
}
